import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { LayoutDashboard, Home, MapPin, PlayCircle, Sparkles, Bell, Settings, LogOut, ExternalLink, ArrowLeft, CalendarDays, BarChart3, ShoppingBag } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

const LINKS = [
  { to: "/admin", label: "Requests", icon: LayoutDashboard, end: true },
  { to: "/admin/reservations", label: "Reservations", icon: CalendarDays },
  { to: "/admin/property", label: "House Info", icon: Home },
  { to: "/admin/recommendations", label: "Local Spots", icon: MapPin },
  { to: "/admin/guides", label: "How-To Guides", icon: PlayCircle },
  { to: "/admin/add-ons", label: "Add-Ons", icon: Sparkles },
  { to: "/admin/orders", label: "Orders", icon: ShoppingBag },
  { to: "/admin/analytics", label: "Analytics", icon: BarChart3 },
  { to: "/admin/reminders", label: "Reminders", icon: Bell },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [mainAdminUrl, setMainAdminUrl] = useState("");

  useEffect(() => {
    api.get("/settings").then((r) => setMainAdminUrl(r.data.main_site_admin_url || "")).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-brand-bg flex flex-col lg:flex-row">
      <aside className="lg:w-64 shrink-0 bg-brand-forest text-brand-bg lg:min-h-screen flex flex-col">
        <div className="p-6 border-b border-white/10">
          <span className="overline text-brand-bg/50">Host Dashboard</span>
          <h1 className="font-display text-2xl tracking-tight mt-1">MYAZBNB.COM</h1>
        </div>
        <nav className="flex-1 p-3 flex lg:flex-col gap-1 overflow-x-auto">
          {LINKS.map((l) => {
            const Icon = l.icon;
            return (
              <NavLink
                key={l.to} to={l.to} end={l.end}
                data-testid={`nav-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
                className={({ isActive }) =>
                  `flex items-center gap-3 rounded-xl px-4 py-3 text-sm font-medium whitespace-nowrap transition-colors ${
                    isActive ? "bg-brand-terracotta text-white" : "text-brand-bg/70 hover:bg-white/10"
                  }`
                }
              >
                <Icon size={18} /> {l.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="p-3 border-t border-white/10 space-y-1">
          {mainAdminUrl && (
            <a href={mainAdminUrl} data-testid="back-to-main-site" className="w-full flex items-center gap-3 rounded-xl px-4 py-3 text-sm text-brand-bg/70 hover:bg-white/10 transition-colors">
              <ArrowLeft size={18} /> myAZbnb Admin
            </a>
          )}
          <button onClick={() => navigate("/")} data-testid="view-guidebook" className="w-full flex items-center gap-3 rounded-xl px-4 py-3 text-sm text-brand-bg/70 hover:bg-white/10 transition-colors">
            <ExternalLink size={18} /> View Guidebook
          </button>
          <button onClick={logout} data-testid="logout-button" className="w-full flex items-center gap-3 rounded-xl px-4 py-3 text-sm text-brand-bg/70 hover:bg-white/10 transition-colors">
            <LogOut size={18} /> Log Out
          </button>
        </div>
      </aside>
      <main className="flex-1 p-5 sm:p-8 max-w-5xl w-full min-w-0 mx-auto"><Outlet /></main>
    </div>
  );
}
